import t from "../../../../../../../../../i18n";
import { Scatter } from "@ui/IconV2/react";
import { colors } from "@ui/Theme";
import type { BlockPlotImportT } from "../../../../../../schema/block/plot";
import React from "react";
import { createLayerTemplate } from "./layer";

export const icon = () => <Scatter size="l" color={colors.carbon800} />;

export const title = t("project.dashboard.block.template.scatterplot.title");

export const description = t("project.dashboard.block.template.scatterplot.description");

export const layer = createLayerTemplate("scatter");

export const block: Omit<BlockPlotImportT, "dashboardId" | "position"> = {
  kind: "PLOT",
  data: {
    title: undefined,
    // resources: [],
  },
  config: {
    options: {
      displayInvalidatedDataPoints: false,
      groupYAxesByUnit: true,
      sync: true,
    },
    layers: [layer],
  },
};
